document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('mobile-menu-toggle');
  var nav = document.getElementById('mobile-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('mobile-nav--open');
      toggle.classList.toggle('active');
    });
  }

  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var targetId = this.getAttribute('href').slice(1);
      var target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', async function (e) {
      e.preventDefault();

      var submitButton = productForm.querySelector('[type="submit"]');
      var originalLabel = submitButton ? submitButton.innerHTML : '';
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Opening secure checkout…';
      }

      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(productForm)
        });

        if (!response.ok) {
          throw new Error('Could not add this item to your order.');
        }

        window.location.assign('/checkout');
      } catch (error) {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.innerHTML = originalLabel;
        }
        window.alert('We could not open checkout. Please try again.');
      }
    });
  }
});
